<template>
  <div style="display: flex; flex-direction: column; height: 100%">
    <div style="display: flex; flex-direction: column">
      <v-text-field
        v-model="userEditObj.name"
        label="Name"></v-text-field>
      <SelectIcon
        v-model="userEditObj.icon"
        label="Icon"></SelectIcon>
      <!-- hex color picker using vuetify picker -->
      <v-color-picker
        mode="hex"
        :modes="['hex']"
        v-model="userEditObj.color"
        label="Color"
        hide-details></v-color-picker>
    </div>
  </div>
</template>
<script setup>
import SelectIcon from '../Shared/SelectIcon.vue';
const props = defineProps(['userEditObj']);
</script>
